export const stringsKey = "TemplateList";
export const englishStrings = {
	selectStatus: "Select Status",
	addTemplateBtnTooltip: "New Template",
	templateListFilterErrorMessage:
		"Error loading template list, Please try again",
	templateListErrorMessage: "Failed to load template list!",
	title: "My Batch Messages",
	batchMessagingOption: "Batch Messaging",
	requestForHelpOption: "Request For Help",
};
